import { faCopy, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const Referral = () => {
  const { t } = useTranslation();
  let { user } = useContext(AuthContext);
  const notification = useToastContext();


  return (
    <>
      <Toolbar title={t("NAV_REFER_AND_EARN")} showBackBtn={true} />
      <div className="flex justify-center w-full">
        <div className="container px-5 text-center flex flex-col justify-center items-center h-full">
          <span className="font-medium text-lg">{t("REFER_AND_EARN_UPTO")}</span>
          <div className="h-[10rem] w-[10rem] bg-[var(--glass)] mt-4 flex justify-center items-center rounded-full">
            <FontAwesomeIcon icon={faUserPlus} className="h-[4rem] w-[4rem]" />
          </div>
          <span className="font-medium text-base mt-4">{t("REFER_AND_EARN_REFERRAL")}</span>
          <div className="flex gap-2 items-center">
            <span className="font-bold text-2xl my-2">{user.referral_code}</span>
            <FontAwesomeIcon
              icon={faCopy}
              size={"lg"}
              className="cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(user.referral_code).then(() => {
                  notification.success(t("REFERAL_CODE_CLIPBOARD"));
                });
              }}
            />
          </div>
          <div className="mt-5 font-medium">{t("REFER_AND_EARN_INVITE")}</div>
        </div>
      </div>
    </>
  );
};

export default Referral;
